import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { TrendingUp, TrendingDown } from 'lucide-react';
import { fetchTopPerformingAgents } from '@/lib/api';

export function TopPerformingAgents() {
  const navigate = useNavigate();
  const [agents, setAgents] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadData() {
      setLoading(true);
      const result = await fetchTopPerformingAgents(5);
      setAgents(result);
      setLoading(false);
    }
    loadData();
  }, []);

  if (loading) {
    return (
      <div className="bg-card border border-border rounded-xl p-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-bold text-foreground">Top Performing Agents</h2>
        </div>
        <div className="h-[200px] flex items-center justify-center">
          <div className="text-muted-foreground">Loading...</div>
        </div>
      </div>
    );
  }

  if (!agents || agents.length === 0) {
    return (
      <div className="bg-card border border-border rounded-xl p-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-bold text-foreground">Top Performing Agents</h2>
        </div>
        <div className="flex flex-col items-center justify-center py-8 text-center gap-2">
          <div className="text-muted-foreground">No agent performance data available</div>
          <div className="text-sm text-muted-foreground">Create agents and complete simulations to see top performers</div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-xl p-6">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-bold text-foreground">Top Performing Agents</h2>
        <button 
          className="text-primary text-sm font-medium hover:underline"
          onClick={() => navigate('/admin/agents')}
        >
          View All
        </button>
      </div>
      <div className="space-y-4">
        {agents.map((agent, idx) => (
          <div key={idx} className="flex items-center justify-between p-4 border border-border rounded-lg hover:bg-accent/50 transition-colors">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-success/20 to-primary/20 flex items-center justify-center">
                <span className="text-sm font-bold text-primary">{agent.initials}</span>
              </div>
              <div>
                <div className="font-semibold text-foreground">{agent.name}</div>
                <div className="text-sm text-muted-foreground">{agent.specialty}</div>
              </div>
            </div>
            <div className="text-right">
              <div className="flex items-center gap-2">
                <span className="text-lg font-bold text-foreground">{agent.avgScore ?? '—'}</span>
                {agent.trend === 'up' ? (
                  <TrendingUp size={16} className="text-green-600" />
                ) : (
                  <TrendingDown size={16} className="text-red-600" />
                )}
              </div>
              <div className="text-sm text-muted-foreground">{agent.completions} completions</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
